export const setit = (cname, cvalue, exdays) => {
   const d = new Date();
   d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
   const expires = "expires=" + d.toUTCString();
   document.cookie =
      cname + "=" + JSON.stringify(cvalue) + ";" + expires + ";path=/";
};
export const getit = (cname) => {
   let result = document.cookie.match(new RegExp(cname + "=([^;]+)"));

   result ? (result = JSON.parse(result[1])) : "";
   return result;
};

export const convertDateToYYYYMMDD = (date = "") => {
   const splittedDate = date.split("-");

   if (splittedDate[splittedDate.length - 1].length === 4) {
      date = splittedDate.reverse().join("-");
   }

   return date;
};

export const convertDateToDDMMYYYY = (date = "") => {
   return date.split("-").reverse().join("-");
};

export const splitEventTime = (time = "") => {
   if (!time) {
      return { startTime: "", endTime: "" };
   }

   const splitedTime = time.split(" - ");
   return { startTime: splitedTime[0], endTime: splitedTime[1] };
};

export const checkTimeStamp = (startTime, endTime) => {
   const convertedStartTime = new Date(startTime).getTime();
   const convertedEndTime = new Date(endTime).getTime();

   return convertedEndTime > convertedStartTime;
};

export const convertUtcToTime = (date) => {
   if (!date) {
      return "";
   }

   const time = new Date(date);

   const hour =
      time.getHours() == 0
         ? 12
         : time.getHours() > 12
         ? time.getHours() - 12
         : time.getHours();
   const min =
      time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
   const ampm = time.getHours() < 12 ? "AM" : "PM";
   const convertedTime = `${hour}:${min} ${ampm}`;

   return convertedTime;
};

const padTo2Digits = (num) => {
   return num.toString().padStart(2, "0");
};

export const formatDate = (date) => {
   return [
      padTo2Digits(date.getDate()),
      padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
   ].join("-");
};
